<template>
  <div class="w-full flex flex-col gap-2">
    <label
      class="text-[#121212] font-semibold text-[16px] leading-[24px] flex items-center gap-1"
      style="font-family: 'Open Sans'; font-weight: 600"
    >
      {{ label }}
      <span
        v-if="required"
        class="text-[#E25C5C] font-[500] text-[16px] leading-[24px]"
        >*</span
      >
    </label>
    <div
      class="w-full h-[46px] border border-[#CCCCCC] rounded-[8px] flex items-center px-3"
      :class="{ 'border-red-500': errorMessage }"
    >
      <input
        :type="type"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="w-full h-full text-[#1c1c1c] text-[14px] leading-[22.4px] outline-none bg-transparent"
        style="font-family: 'Open Sans'; font-weight: 400"
        :placeholder="placeholder"
      />
    </div>
    <p v-if="errorMessage" class="text-red-500 text-[14px]">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  label: String,
  modelValue: String,
  type: { type: String, default: "text" },
  placeholder: String,
  errorMessage: String,
  required: { type: Boolean, default: false },
});
defineEmits(["update:modelValue"]);
</script>
